define([
	"dojo/_base/declare",
	"csi",
	"csi/_base/underscore",
	"csi/table/AggregateFrom",
	"csi/xml",
	"csi/xml/Query",
	"./PartMaterialBOMSectionMixin"
], function(declare,csi,_,AggregateFrom,xml,Query,PartMaterialBOMSectionMixin) {

	return declare([AggregateFrom, PartMaterialBOMSectionMixin], {
		applyActionFilters: function(/*csi.view.Widget*/view) {
			//summary: filter Theme Placements based on what BOM Section the action initiated from
			var qr = this.widget.getQueryResultByDomNode(this.refNode);
			var bomSectionDefUrl = qr.parentResult.groupValue;
			var bomSectionDef = (xml.isValidURL(bomSectionDefUrl)) ? this.m_cache.getNode(bomSectionDefUrl) : null;

			// The type must be checked because table can be grouped by attributes other than BOM section
			if (bomSectionDef && bomSectionDef.$Type == "BOMSectionDefinition") {
				var fromSectionUrl;  //Restrict resulting Theme Placements on only this section

				if (!bomSectionDef.AdHoc) {
					// Initiated from a formal section: Display placements only from the matching section on the Theme BOM.
					fromSectionUrl = bomSectionDefUrl;
				} else {
					// Initiated from "Ad Hoc" section: if the Theme BOM has an ad hoc section with the same name, display placements only from the matching section on the Theme BOM.
					var sectionName = bomSectionDef.$Name;
					if (sectionName) {
						fromSectionUrl = this.findThemeAdHocSection(qr.parentUrl, sectionName);
					}
				}

				if (fromSectionUrl) {
					// Filter the aggregation view to display only the relevant section
					view._sectionToDisplay = fromSectionUrl;

					// Filter the aggregation view to display only relevant Theme Placements
					view.relRoot.addQuery(new Query().RefAttr("DSSection", xml.OP_EQUALS, fromSectionUrl));
				}
			}

			let groupProductType = this.widget.getActionElementGroupProductType(this);
			if (groupProductType) {
				view.relRoot.addQuery(new Query().RefAttr("ProductType", xml.OP_EQUALS, groupProductType, xml.path("Actual")));
			}

			this.inherited(arguments);
		},

		findThemeAdHocSection: function(/*BOMRevision URL*/parentUrl, /*String*/name) {
			// Find ad-hoc Section on Theme with the matching name, null if no match
			var cache = this.m_cache;
			var parentNode = cache.getNode(parentUrl);
			var theme = cache.getPathNode(parentNode, "Child:__Parent__/Child:__Parent__/Child:Theme");
			if (!theme)
				return null;

			var themeSectionURL = _.find(theme.OwnedSections, function(section) {
				return cache.getNode(section).$Name == name;
			});

			// if no theme section URL is found, pass a dummy value ("invalid_section") to the query so nothing will get picked up
			return themeSectionURL || "invalid_section";
		}
	});
});
